module.exports = __webpack_public_path__ + "static/media/imgGallery5.7226a3a1.jpg";